import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Schützt Modul-Routen anhand der RBAC-Rechte.
 * Erwartet in den Route-`data`: `{ module: 'notizen', action?: 'READ' | 'WRITE' }`.
 * Ohne `module` ist die Route frei (nur Login nötig). Kein Zugriff → /dashboard.
 */
export const permissionGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const module = route.data?.['module'] as string | undefined;
  const action = (route.data?.['action'] as 'READ' | 'WRITE') ?? 'READ';

  if (!module || auth.can(module, action)) {
    return true;
  }
  return router.createUrlTree(['/dashboard']);
};

/** Nur für Admins (System-Rolle ADMIN). Sonst → /dashboard. */
export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.isAdmin() ? true : router.createUrlTree(['/dashboard']);
};
